"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _react = _interopRequireWildcard(require("react"));
var _carouselImages = _interopRequireDefault(require("../styles/carousel-images.css"));
var _carouselSingleImage = _interopRequireDefault(require("./carousel-single-image"));
var _carouselSingleText = _interopRequireDefault(require("./carousel-single-text"));
var _controlsDesktopButtons = _interopRequireDefault(require("./controls-desktop-buttons"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization;
var CarouselImagesContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CarouselImagesContainer, _React$Component);
  function CarouselImagesContainer() {
    var _this;
    _this = _React$Component.call(this) || this;
    _this.state = {
      items: []
    };
    _this.placeLastImageBeforeFirst = _this.placeLastImageBeforeFirst.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateItemsState = _this.updateItemsState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleControlsPosition = _this.handleControlsPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.carouselControlsWrapperRef = /*#__PURE__*/(0, _react.createRef)();
    _this.carouselWrapperRef = /*#__PURE__*/(0, _react.createRef)();
    _this.imageWidth = 2160;
    return _this;
  }
  var _proto = CarouselImagesContainer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      items = _this$props.items,
      carouselImagesLength = _this$props.carouselImagesLength,
      twoSlidesCarousel = _this$props.twoSlidesCarousel;
    window.addEventListener('resize', this.handleControlsPosition);
    if (items && carouselImagesLength !== twoSlidesCarousel) {
      return this.placeLastImageBeforeFirst();
    }
    return this.updateItemsState();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // move carousel controls between image and text on load and on carousel item change
    var _prevState$items = prevState.items,
      items = _prevState$items === void 0 ? [] : _prevState$items;
    if (items.length) {
      this.setControlHeight();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleControlsPosition);
  };
  _proto.handleControlsPosition = function handleControlsPosition() {
    // keep carousel controls between image and text when resizing window
    var carouselConstrols = this.carouselControlsWrapperRef.current;
    var selectedImage = this.carouselWrapperRef.current.querySelector('li[selecteditem=true] img');
    var controlsOffset = 10;
    carouselConstrols.style.top = selectedImage.height + controlsOffset + "px";
  };
  _proto.setControlHeight = function setControlHeight() {
    var carouselConstrols = this.carouselControlsWrapperRef.current;
    var selectedImage = this.carouselWrapperRef.current.querySelector('li[selecteditem=true] img');
    var controlsOffset = 10;

    // if image has not loaded wait for it to load and then get the correct height
    if (selectedImage !== null) {
      if (selectedImage.height < 2) {
        // eslint-disable-line
        selectedImage.onload = function onload() {
          carouselConstrols.style.top = this.height + controlsOffset + "px";
        };
        // if image has loaded, get the height
      } else {
        carouselConstrols.style.top = selectedImage.height + controlsOffset + "px";
      }
    }
  };
  _proto.updateItemsState = function updateItemsState() {
    var items = this.props.items;
    this.setState({
      items: items
    });
  }

  // places last image before first in carousel so user can always slide pictures in left or right
  ;
  _proto.placeLastImageBeforeFirst = function placeLastImageBeforeFirst() {
    var items = this.props.items;
    var lastItem = items.slice(items.length - 1);
    var newArr = [].concat(lastItem, items.slice(0, items.length - 1));
    this.setState({
      items: newArr
    });
  };
  _proto.noJavascriptRender = function noJavascriptRender() {
    var _this2 = this;
    var _this$props2 = this.props,
      sliding = _this$props2.sliding,
      getOrder = _this$props2.getOrder,
      items = _this$props2.items,
      theme = _this$props2.theme;
    var isWebp = true;
    var isBackground = false;
    var imageQuality = 70;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items && items.map(function (carouselItem, i) {
      var imagePath = handleNestedProp(carouselItem, 'carouselItem.image.image');
      var itemKey = imagePath === ' ' ? i : imagePath.replace(/[^\w]+/g, '');
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: itemKey,
        style: {
          order: getOrder(i)
        },
        className: _carouselImages["default"].textVisible
      }, /*#__PURE__*/_react["default"].createElement(_carouselSingleImage["default"], {
        src: appendImageOptimization(imagePath, _this2.imageWidth, isBackground, isWebp, imageQuality),
        srcSet: [appendImageOptimization(imagePath, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(imagePath, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imagePath, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(imagePath, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imagePath, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imagePath, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
        altText: handleNestedProp(carouselItem, 'carouselItem.image.altText'),
        sizes: "(min-width: 768px) 70vw, 50vw",
        sliding: sliding
      }), /*#__PURE__*/_react["default"].createElement(_carouselSingleText["default"], {
        index: i,
        theme: theme,
        paragraph: handleNestedProp(carouselItem, 'carouselItem.titleAndText.text')
      }));
    }));
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props3 = this.props,
      sliding = _this$props3.sliding,
      getOrder = _this$props3.getOrder,
      direction = _this$props3.direction,
      carouselImagesLength = _this$props3.carouselImagesLength,
      twoSlidesCarousel = _this$props3.twoSlidesCarousel,
      theme = _this$props3.theme,
      updateTextBoxSizes = _this$props3.updateTextBoxSizes,
      controls = _this$props3.controls,
      handleSlide = _this$props3.handleSlide,
      visibleImageIndex = _this$props3.visibleImageIndex;
    var items = this.state.items;
    var isWebp = true;
    var isBackground = false;
    var imageQuality = 70;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.length > 1 && /*#__PURE__*/_react["default"].createElement(_controlsDesktopButtons["default"], {
      theme: theme,
      handleSlidePrev: function handleSlidePrev() {
        return handleSlide(visibleImageIndex, carouselImagesLength, -1);
      },
      handleSlideNext: function handleSlideNext() {
        return handleSlide(visibleImageIndex, carouselImagesLength, 1);
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.carouselControlsWrapperRef,
      className: _carouselImages["default"].controlsWrapper + " " + _carouselImages["default"].carouselControls_showMobile
    }, controls('showMobile')), /*#__PURE__*/_react["default"].createElement("ul", {
      ref: this.carouselWrapperRef,
      className: _carouselImages["default"].carouselImages + " " + (sliding ? _carouselImages["default"].sliding : '') + " " + (direction === -1 ? _carouselImages["default"].prev : '') + " " + (carouselImagesLength === 1 ? _carouselImages["default"].singleSlide : '') + " " + (carouselImagesLength === twoSlidesCarousel ? _carouselImages["default"].twoSlides : '')
    }, items && items.map(function (carouselItem, i) {
      var imagePath = handleNestedProp(carouselItem, 'carouselItem.image.image');
      var itemKey = imagePath === ' ' ? i : imagePath.replace(/[^\w]+/g, '');
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: itemKey,
        style: {
          order: getOrder(i)
        },
        className: (getOrder(i) === 1 ? _carouselImages["default"].textVisible : '') + " " + (getOrder(i) === 0 && items.length <= 1 ? _carouselImages["default"].oneImage : ''),
        selecteditem: getOrder(i) === 1 ? 'true' : 'false'
      }, /*#__PURE__*/_react["default"].createElement(_carouselSingleImage["default"], {
        src: appendImageOptimization(imagePath, _this3.imageWidth, isBackground, isWebp, imageQuality),
        srcSet: [appendImageOptimization(imagePath, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(imagePath, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imagePath, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(imagePath, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imagePath, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imagePath, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
        altText: handleNestedProp(carouselItem, 'carouselItem.image.altText'),
        sizes: "(min-width: 768px) 70vw, 50vw",
        sliding: sliding,
        onLoadComplete: _this3.handleControlsPosition
      }), /*#__PURE__*/_react["default"].createElement(_carouselSingleText["default"], {
        updateTextBoxSizes: updateTextBoxSizes,
        theme: theme,
        paragraph: handleNestedProp(carouselItem, 'carouselItem.titleAndText.text')
      }));
    }), /*#__PURE__*/_react["default"].createElement("noscript", {
      className: _carouselImages["default"].noScript
    }, this.noJavascriptRender())));
  };
  return CarouselImagesContainer;
}(_react["default"].Component);
exports["default"] = CarouselImagesContainer;